import React, { useEffect, useState, useCallback } from "react";
import Video from "./Video";

export default function Channel() {
  const num = Math.floor(100000 + Math.random() * 900000);
    const serverLink = "https://api.ndsql.top/tv/index.json?id="+num;

    const [jsonCDAta, setjsonCDAta] = useState([]);
    const [selectChannel, setSelectChannel] = useState("");
    const [hashCode, setHashCode] = useState(window.location.hash);

    // JSON Load
    useEffect(() => {
        fetch(serverLink)
            .then((response) => response.json())
            .then((data) => {
                setjsonCDAta(data);
            })
            .catch((error) => {
                console.error("Fetch Error:", error);
            });
    }, []);

    // Hash অনুযায়ী Channel Load
    const loadChannel = useCallback(() => {
        if (jsonCDAta.length === 0) return;

        const hash = window.location.hash.replace("#", "");

        if (hash) {
            const channel = jsonCDAta.find(
                (item) => item.username === hash
            );

            if (channel) {
                setSelectChannel(channel.live);
                setHashCode(window.location.hash);
                return;
            }
        }

        // প্রথম Channel Default
        const first = jsonCDAta[0];
        setSelectChannel(first.live);
        window.location.hash = first.username;
        setHashCode("#" + first.username);

    }, [jsonCDAta]);

    // JSON Load হওয়ার পরে
    useEffect(() => {
        loadChannel();
    }, [loadChannel]);

    // Hash Change Listen
    useEffect(() => {
        const handleHashChange = () => {
            loadChannel();
        };

        window.addEventListener("hashchange", handleHashChange);

        return () => {
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, [loadChannel]);

    // Channel Change
    const mirrorVinChannel = (username) => {
        window.location.hash = username;
    };

    return (
        <>
            <div id={window.location.hash.replace("#", "")}>
                <Video data={selectChannel} />
            </div>

            <div className="w100">
                <h2
                    style={{
                        textAlign: "center",
                        margin: "20px 0",
                    }}
                >
                    Channel
                </h2>

                <hr />

                <div className="flex center medel wrap">
                    {jsonCDAta.map((item, index) => (
                        <div
                            key={index}
                            className={`channel flex center medel ${
                                hashCode === "#" + item.username
                                    ? "active"
                                    : ""
                            }`}
                            onClick={() =>
                                mirrorVinChannel(item.username)
                            }
                        >
                            <img
                                className="channel-img"
                                src={item.icon || undefined}
                                alt={item.name}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}